<template>
  <div class="image_card">
    <v-card loading="false" outlined tile :width="props.width">
      <v-img
        :width="props.width"
        :height="props.height"
        :contain="props.contain || false"
        :src="
          uploadImage.image_path
            ? setting.cdn + uploadImage.image_path
            : uploadImage.image_base64
        "
        v-if="uploadImage.image_path || uploadImage.image_base64"
      ></v-img>
      <v-img
        :width="props.width"
        :height="props.height"
        src="@/assets/images/no_image.jpg"
        v-else
      ></v-img>
      <v-card-actions>
        <input
          name="upload_file"
          ref="upload"
          type="file"
          style="display: none"
          @change="onImageUploaded"
        />
        <v-btn icon>
          <v-icon @click="$refs.upload.click()">mdi-upload</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon @click="onImageDelete()">mdi-delete</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { set, toRefs, reactive, watch } from "@vue/composition-api";
import setting from "@/common/setting.js";
import store from "@/store/index.js";
import { repositoryFactory } from "@/repository/repositoryFactory";

export default {
  props: ["width", "height", "category_code", "image_path", "contain"],
  setup(props, ctx) {
    const fileRepository = repositoryFactory.get("file");
    const state = reactive({
      uploadImage: {
        "image_path": null,
        "image_base64": null,
        "image_base64_type": null,
      },
    });

    watch(
      () => props.image_path,
      (newVal) => {
        if (newVal) {
          state.uploadImage.image_path = newVal;
        }
      },
      { immediate: true }
    );
    watch(
      () => props.image_base64,
      (newVal) => {
        if (newVal) {
          state.uploadImage.image_base64 = newVal;
        }
      },
      { immediate: true }
    );
    watch(
      () => props.image_base64_type,
      (newVal) => {
        if (newVal) {
          state.uploadImage.image_base64_type = newVal;
        }
      },
      { immediate: true }
    );

    const onImageDelete = () => {
      state.uploadImage = {
        "image_path": null,
        "image_base64": null,
        "image_base64_type": null,
      };
    };

    const createImage = async (image) => {
      const reader = new FileReader();
      // imageをreaderにDataURLとしてattachする
      reader.readAsDataURL(image);
      // readAdDataURLが完了したあと実行される処理
      reader.onload = () => {
        state.uploadImage = {
          "image_path": null,
          "image_base64": reader.result,
          "image_base64_type": image.type,
        };
      };
    };

    const onImageUploaded = (e) => {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const type = files[0].type;
      if (
        type !== "image/webp" &&
        type !== "image/jpeg" &&
        type !== "image/gif" &&
        type !== "image/png"
      ) {
        alert(
          ".webp, .jpg, .gif, .pngのいずれかのファイルのみ許可されています"
        );
        return;
      }
      createImage(files[0], e.target.getAttribute("upload_index"));
    };

    const saveImage = async () => {
      if (
        state.uploadImage.image_base64 &&
        state.uploadImage.image_base64.length > 0
      ) {
        // ここで画像保存処理(サーバにアップロードする)
        let ext = state.uploadImage.image_base64_type.substr(
          state.uploadImage.image_base64_type.indexOf("/") + 1
        );
        if (ext == "jpeg") {
          ext = "jpg";
        }
        const d = new Date();
        // アップロード用のファイル名を生成
        const file_name =
          "_tmp_" +
          store.getters["shops/currentShop"].id +
          "_" +
          d.getTime() +
          "." +
          ext;
        const image_params = {
          shop_id: store.getters["shops/currentShop"].id,
          base64_image: state.uploadImage.image_base64,
          file_name: file_name,
        };
        // ファイルアップロード
        const upload_result = await fileRepository
          .upload_hplink(image_params)
          .then((response) => {
            if (response.data) {
              if (response.data.status) {
                // 画像追加OK
                set(state, "uploadImage", {
                  "image_path": response.data.file_name,
                  "image_base64": null,
                  "image_base64_type": null,
                });
              } else {
                // 画像追加NG
                alert(response.data.message);
              }
              return response.data;
            }
          })
          .catch((error) => {
            throw "ERROR:fileRepository.upload_hplink (" + error + ")";
          });
        // アップロードに失敗した場合、抜ける。
        if (!upload_result.status) return "";

        return upload_result.file_name;
      } else {
        return state.uploadImage.image_path ?? "";
      }
    };

    return {
      setting,
      props,
      ...toRefs(state),
      onImageDelete,
      onImageUploaded,
      createImage,
      saveImage,
    };
  },
};
</script>
